export default "__VITE_ASSET__BS5tvS9n__"